import Category from '@material-ui/icons/Category';

import List from './List';

export default {
  list: List,
  /*  create: Create,
  edit: Edit, */
  icon: Category,
};
